import React from 'react';
import { motion } from 'framer-motion';
import { useDatabase } from '../../context/DatabaseContext';
import ReactECharts from 'echarts-for-react';

const CategoryOverview = () => {
  const { getCategories } = useDatabase();
  const categories = getCategories();

  const chartOption = {
    title: {
      text: 'Produktverteilung nach Kategorien',
      left: 'center',
      textStyle: {
        fontSize: 16,
        fontWeight: 'bold',
        color: '#1f2937'
      }
    },
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    legend: {
      orient: 'vertical',
      left: 'left',
      data: categories.map(cat => cat.name),
      textStyle: {
        color: '#374151'
      }
    },
    color: ['#dc2626', '#000000', '#ef4444', '#7f1d1d', '#991b1b'],
    series: [
      {
        name: 'Produktkategorien',
        type: 'pie',
        radius: '60%',
        center: ['50%', '60%'],
        data: categories.map(cat => ({
          value: cat.count,
          name: cat.name
        })),
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        },
        itemStyle: {
          borderWidth: 2,
          borderColor: '#fff'
        }
      }
    ]
  };

  return (
    <motion.div
      className="bg-white rounded-lg shadow-sm border border-gray-200 p-6"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
    >
      <div className="mb-4">
        <h2 className="text-xl font-bold text-gray-900">Kategorieübersicht</h2>
        <p className="text-gray-600">Verteilung der Produkte nach ETIM-Klassifikation</p>
      </div>
      
      <div className="h-80">
        <ReactECharts 
          option={chartOption} 
          style={{ height: '100%', width: '100%' }} 
        />
      </div>

      <div className="mt-4 grid grid-cols-2 gap-4">
        {categories.slice(0, 4).map((category, index) => (
          <div key={category.code} className="text-center p-3 bg-gray-50 rounded-lg border border-gray-100">
            <p className="text-sm text-gray-600 font-medium">{category.name}</p>
            <p className="text-lg font-bold text-gray-900">{category.count}</p>
            <p className="text-xs text-gray-500 font-mono">{category.code}</p>
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default CategoryOverview;